import React from "react";
import styles from "../css/Contact.css";
import {Header} from "./Introduce";
import {Button, Toast} from "antd-mobile";
import {request} from "../request";
import {checkToekn} from "../tools/wechatBrower";

class App extends React.Component {
    state = {};

    async componentDidMount() {
        let res = await checkToekn();
    }

    render() {
        return (
            <div>
                <Header text="联系我们"/>
                <div className={styles.main}>
                    <img
                        className={styles.img}
                        src={require("../static/1615172358318.jpg")}
                        alt=""
                    />
                    <div className={styles.info}>
                        <img
                            src={require("../static/韩强.jpg")}
                            alt=""
                            style={{width: "100px", borderRadius: "6px"}}
                        />
                        <div className={styles.right}>
                            <p className={styles.text}>实验室负责人：韩强 </p>

                            <p className={styles.text}>联系方式：18201233611/010-62776949</p>

                            <p className={styles.text}>邮箱：hanqiang@mail.tsinghua.edu.cn</p>

                            <p className={styles.text}>
                                收件信息：北京市海淀区清华大学理科楼D308室，韩强，18201233611。
                            </p>
                        </div>
                    </div>

                    <img
                        className={styles.img2}
                        src={require("../static/qrcode.jpg")}
                        alt=""
                    />
                    <div style={{height: "7.5rem"}}>
                        <img
                            style={{marginLeft: "3.25%"}}
                            className={styles.img2}
                            src={require("../static/1.jpg")}
                            alt=""
                            onClick={() => {
                                this.props.history.push("/BigImg");
                            }}
                        />
                    </div>

                    <p
                        className={styles.text}
                        style={{width: "93%", marginTop: "10px"}}
                    >
                        实验室地址：北京市海淀区清华园1号，理科楼（物理系）D308室（清华大学西北门进门左转100米右侧广场一角可见物理系）
                    </p>
                </div>
                <div className={styles.suggest}>
                    <div className={styles.bottom}>
                        <p className={styles.suggestTitle} style={{marginTop: "unset"}}>
                            意见与支持
                        </p>

                        <Button
                            type="primary"
                            style={{
                                backgroundColor: "#AE5CC9",
                                border: 0,
                                width: "3rem",
                                lineHeight: "1rem",
                                fontSize: "0.7rem",
                                borderRadius: "6px",
                            }}
                            className={styles.sub}
                            onClick={() => {
                                if (!document.getElementById("content").value) {
                                    Toast.info("内容不得为空", 1);
                                    return;
                                }

                                request(
                                    "index/suggest",
                                    {
                                        uid: localStorage.getItem("openid"),
                                        content: document.getElementById("content").value,
                                    },
                                    ({data}) => {
                                        data.code === 1
                                            ? Toast.success("感谢您的宝贵建议")
                                            : Toast.fail("发送失败");
                                        document.getElementById("content").value = "";
                                    }
                                );
                            }}
                        >
                            提交
                        </Button>
                    </div>

                    <textarea
                        style={{border: "1px solid #c0cfdc"}}
                        placeholder="请详细说明"
                        className={styles.input}
                        id="content"
                    />
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/Contact.js